import Axios from 'axios'

export const getReport = async (params = {}) => {
  const response = await Axios.get('/reports/getById', { params })
  return response.data
}
